// Analytics Tab Component
import { Button } from '../../../components/ui/button';
import { BarChart3, RefreshCw, MousePointer } from 'lucide-react';

const elementTypeLabels = {
  ticket: 'Biglietto',
  speaker: 'Speaker',
  gallery: 'Galleria',
  gallery_image: 'Immagini Gallery',
  agenda: 'Agenda/Sessioni',
  agenda_tab: 'Tab Agenda (Track)',
  sponsor: 'Sponsor',
  location: 'Location/Mappa',
  video: 'Video',
};

export const AnalyticsTab = ({ 
  editingEvent, 
  eventAnalytics, 
  analyticsLoading,
  loadEventAnalytics,
  resetEventAnalytics
}) => {
  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <div>
          <h3 className="font-heading font-semibold flex items-center gap-2">
            <BarChart3 size={20} className="text-primary" />
            Statistiche Click
          </h3>
          <p className="text-sm text-muted-foreground">
            Monitora le interazioni degli utenti con gli elementi dell'evento
          </p>
        </div>
        <div className="flex gap-2">
          <Button 
            type="button" 
            variant="outline" 
            size="sm"
            onClick={() => loadEventAnalytics(editingEvent?.id)}
            disabled={!editingEvent?.id || analyticsLoading}
          >
            <RefreshCw size={16} className={`mr-2 ${analyticsLoading ? 'animate-spin' : ''}`} />
            Aggiorna
          </Button>
          <Button 
            type="button" 
            variant="destructive" 
            size="sm"
            onClick={() => resetEventAnalytics(editingEvent?.id)}
            disabled={!editingEvent?.id}
          >
            Azzera Statistiche
          </Button>
        </div>
      </div>

      {!editingEvent?.id ? (
        <div className="text-center py-12 text-muted-foreground">
          <BarChart3 size={48} className="mx-auto mb-4 opacity-50" />
          <p>Salva l'evento per visualizzare le statistiche</p>
        </div>
      ) : analyticsLoading ? (
        <div className="text-center py-12 text-muted-foreground">
          <RefreshCw size={32} className="mx-auto mb-4 animate-spin" />
          <p>Caricamento statistiche...</p>
        </div>
      ) : !eventAnalytics ? (
        <div className="text-center py-12 text-muted-foreground">
          <MousePointer size={48} className="mx-auto mb-4 opacity-50" />
          <p>Clicca "Aggiorna" per caricare le statistiche</p>
        </div>
      ) : (
        <div className="space-y-6">
          {/* Total clicks summary */}
          <div className="glass rounded-xl p-6 text-center">
            <p className="text-sm text-muted-foreground mb-1">Click Totali</p>
            <p className="font-heading text-4xl font-bold text-primary">
              {eventAnalytics.total_clicks || 0}
            </p>
          </div>

          {/* Stats by type */}
          {eventAnalytics.stats_by_type?.length > 0 ? (
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              {eventAnalytics.stats_by_type.map((stat) => (
                <div key={stat.element_type} className="glass rounded-xl p-4">
                  <div className="flex items-center justify-between mb-3">
                    <h4 className="font-semibold flex items-center gap-2">
                      <MousePointer size={16} className="text-primary" />
                      {elementTypeLabels[stat.element_type] || stat.element_type}
                    </h4>
                    <span className="text-lg font-bold text-primary">
                      {stat.total_clicks} click
                    </span>
                  </div>
                  
                  {stat.items?.length > 0 && (
                    <div className="space-y-2 max-h-48 overflow-y-auto">
                      {stat.items.map((item, idx) => (
                        <div 
                          key={`${stat.element_type}-${idx}`}
                          className="flex items-center justify-between text-sm bg-white/5 rounded-lg px-3 py-2"
                        >
                          <span className="text-muted-foreground truncate flex-1">
                            {item.element_name || item.element_id || 'N/A'}
                          </span>
                          <span className="font-medium ml-2">
                            {item.clicks} click
                          </span>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              ))}
            </div>
          ) : (
            <div className="text-center py-8 text-muted-foreground">
              <p>Nessun click registrato per questo evento</p>
            </div>
          )}
        </div>
      )}
    </div>
  );
};
